import type { VirtualFile } from "@pdfking/pdfengine"
import type { FileStorage } from "../types/FileStorage"
import { CreateMixin } from "@pdfking/reactivity/preact"
import { Items, KeyDrop, RecordMerge } from "@pdfking/tfunc"

export const BaseProviderMixin = CreateMixin({
  data: {
    files: {} as Record<string, VirtualFile>,
    store: null as FileStorage | null,
  },
  methods: {
    add_files(files: Record<string, VirtualFile>) {
      return Promise.all(
        Items(files).map(async ([path, file]) => {
          await this.store.set(path, file)
          this.files = RecordMerge(this.files, { [path]: file })
        })
      )
    },
    async populate() {
      this.files = await this.store.startswith()
    },
    remove_files(file_ids: string[]) {
      return Promise.all(
        file_ids.map(async (id: string) => {
            await this.store.delete(id)
            console.log('removing', {id, files: this.files})
          this.files = KeyDrop(this.files, [id])
        })
      )
    },
  },
  init() {
    this.populate()
  },
})
